var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "background-video-container"
  }, [_c("video", {
    staticClass: "background-video",
    attrs: {
      muted: "",
      autoplay: "",
      loop: "",
      playsinline: "",
      preload: "auto",
      id: "background-video",
      poster: _vm.$whitelabel.productionS3RootUrl + "/images/landing/background_video_poster.jpg"
    },
    domProps: {
      muted: true
    }
  }, [_c("source", {
    attrs: {
      src: _vm.$whitelabel.productionS3RootUrl + "/hero_video_stabilized.mp4",
      type: "video/mp4"
    }
  })]), _c("div", {
    staticClass: "overlay"
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };